var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"entidades-toolbar-entidades"}},[_c('v-toolbar',{staticClass:"mb-2",attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"display-1"},[_vm._v("\n      Entidades\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }